// MODALS
export const TOS_MODAL = 'TOS_MODAL';
